<template>
  <div class="m1">
		<div>
			<h2 class="dark-orange--text font30">BCEI</h2>
			<h3 class="dark-orange--text">Business Critical Equipment & Infrastructure</h3>
			<div>
				<h3 class="dark-orange--text font20">Por área</h3>
				<Circles :little_circles_izq="acXarea.little_circles_izq" :big_circle="acXarea.big_circle"/>
			</div>
		</div>
		<div>
			<h2 class="dark-orange--text font30">CSP</h2>
			<h3 class="dark-orange--text">Critical Spare Part</h3>
			<div>
				<h3 class="dark-orange--text font20">Por área</h3>
				<Circles :little_circles_izq="spXarea.little_circles_izq" :big_circle="spXarea.big_circle" :little_circles_der="spXarea.little_circles_der"/>
			</div>
		</div>

		<div>
			<h2 class="dark-orange--text font30">Hallazgos P1, P2 y P3 Abiertos</h2>
			<div>
				<h3 class="dark-orange--text font20">Por área</h3>
				<Circles 
				:little_circles_izq="com_opened_findings_per_area.little_circles_izq" 
				:big_circle="com_opened_findings_per_area.big_circle" :little_circles_der="com_opened_findings_per_area.little_circles_der"/>
			</div>
		</div>
	</div>
</template>

<script>
import Circles from '@/modules/CA_SP/components/main/Circulos.vue';

export default {
	data(){
		return {
			opened_findings_per_area:{total: 0},
			critical_asset_by_organization:{total: 0},
			spare_part_by_organization_ri:{total: 0},
			spare_part_by_organization_csp:{total: 0},
		}
	},
  computed: {
		com_opened_findings_per_area(){
			const res = { big_circle: [], little_circles_izq: [] };
			if (!this.opened_findings_per_area) return res;

			const regs = {...this.opened_findings_per_area};
			delete regs.Total;
			Object.keys(regs)
				.forEach(k => isNaN(regs[k]) || res.little_circles_izq.push({label:['', k],content:regs[k]}))
			res.big_circle = [
        this.opened_findings_per_area.Total,
        'Total'
			];
			return res;
		},
		acXarea(){
			const res = { big_circle: [], little_circles_izq: [] };
			if (!this.critical_asset_by_organization) return res;

			const regs = {...this.critical_asset_by_organization};
			delete regs.Total;
			Object.keys(regs)
				.forEach(k => isNaN(regs[k]) || res.little_circles_izq.push({label:['', k],content:regs[k]}))
			res.big_circle = [
        this.critical_asset_by_organization.Total,
        'Total BCEI'
			];
			return res;
		},
		spXarea(){
			//spare_part_type
			const res = { big_circle: [], little_circles_izq: [], little_circles_der: [] };

			/* const regs = {...this.spare_part_by_organization_ri || {}};
			delete regs.Total;
			Object.keys(regs)
				.forEach(k => isNaN(regs[k]) ||  res.little_circles_der.push({label:['RI', k],content:regs[k]})) */

			const regs2 = {...this.spare_part_by_organization_csp || {}};
			delete regs2.Total;
			Object.keys(regs2)
				.forEach(k => isNaN(regs2[k]) || res.little_circles_izq.push({label:['CSP', k],content:regs2[k]}))


			res.big_circle = [
				/* `${this.spare_part_by_organization_csp.Total || 0} | ${this.spare_part_by_organization_ri.Total || 0}`,
				'Total CSP | Total RI' */
				`${this.spare_part_by_organization_csp.Total || 0}`,
				'Total CSP'
			];
			return res;
		},
		home_main(){ return this.$store.getters.home_main }
  },
	components: { Circles },
	created() {
		['critical_asset_by_organization','spare_part_by_organization_ri','spare_part_by_organization_csp']
			.forEach(k => this[k] = this.home_main[k])

    this.requests.getsSimple['aggregate/critical_asset_by_organization']()
			.then(r => this.home_main.critical_asset_by_organization = r)
      .then(r => this.critical_asset_by_organization = r);

    this.requests.getsSimple['dashboard/opened_findings_per_area']()
			/* .then(r => this.home_main.spare_part_by_organization_ri = r) */
      .then(r => this.opened_findings_per_area = r);

    this.requests.getsSimple['dashboard/principal/spare_part/by_organization/csp']()
			.then(r => this.home_main.spare_part_by_organization_csp = r)
      .then(r => this.spare_part_by_organization_csp = r);
	},
  methods: {
		circleCallback(key, subKey, data) {
			//console.log(key,subKey,data)
		}
  }, // methods
};
</script>

<style scoped>
	.m1>div {
		display: inline-block;
		width: 50%;
	}
	.m1>div>div{
		padding: 10px;
	}
</style>
